import React, {useEffect, useState} from "react";
import $ from "jquery";
import pic_create from "../../assets/images/mgsuite/Tabelle_24x24.png";
import pic_list from "../../assets/images/mgsuite/Tabelle_24x24.png";
import ReservierungsListe from "./ReservierungsListe";
import ReservierungEdit from "./ReservierungEdit";
import ReservierungImport from "./ReservierungImport";
import ReservierungsListeFilter from "./ReservierungsListeFilter";
import { useTranslation } from "react-i18next";

const ReservationService = (props) => {
    const { t } = useTranslation();
    const activeRights = JSON.parse(localStorage.getItem("rights"));

    const [selectedType, setSelectedType] = useState("liste");
    const [listFilterOptions, setListFilterOptions] = useState({
        department: null,
        from: null,
        till: null,
    });
    const [editBuchungId, setEditBuchungId] = useState();
    const [searchText, setSearchText] = useState("");
    
    $(".einstellungen-container")
        .css("background-color", "unset")
        .css("color", "unset");
    $("#" + selectedType)
        .css("background-color", "#e9ecef")
        .css("color", "unset");

    function editBuchung(id) {
        setEditBuchungId(id);
        setSelectedType('editBuchung');
    }
    
    function mainView() {
        function renderView() {
            switch (selectedType) {
                case "editBuchung":
                    return (<ReservierungEdit onChange={() => { setSelectedType("liste"); setEditBuchungId(null); }} editId={editBuchungId}>{" "}</ReservierungEdit>);
                case "importBuchungen":
                    return (<ReservierungImport onChange={() => { setSelectedType("liste"); }}>{" "}</ReservierungImport>);
                case "liste":
                    return (<ReservierungsListe filterOptions={listFilterOptions} searchText={searchText} onEdit={(id) => editBuchung(id)}>{" "}</ReservierungsListe>);
            }
        }

        return (
            <div className="left-container-se settings-left booking-service-left">
                {renderView()}
            </div>
        );
    }

    return (
        <div className="pagewrapper-2">
            {mainView()}

            <div className="right-container-se" id="selection">
                <div className="content-name">{t("allgemein.auswahl")}</div>
                <div className="content">
                    <div className="content-group">
                        {activeRights.find((item) => item.includes("ReservationService.Create")) && (
                            <>
                                <div className="einstellungen-container" onClick={() => setSelectedType("editBuchung")}>
                                    <img src={pic_create} alt={t("reservationService.naviLinkCreateReservation")} className="einstellungen-img"/>
                                    {t("reservationService.naviLinkCreateReservation")}
                                </div>

                                <div className="einstellungen-container" onClick={() => setSelectedType("importBuchungen")}>
                                    <img src={pic_create} alt={t("reservationService.naviLinkImportReservation")} className="einstellungen-img"/>
                                    {t("reservationService.naviLinkImportReservation")}
                                </div>
                            </>
                        )}

                        {activeRights.find((item) => item.includes("ReservationService.Get")) && (
                            <div className="einstellungen-container" onClick={() => setSelectedType("liste")}>
                                <img src={pic_list} alt={t("reservationService.naviLinkList")} className="einstellungen-img"/>
                                {t("reservationService.naviLinkList")}
                            </div>)
                        }
                    </div>

                    {selectedType === "liste" && 
                        <ReservierungsListeFilter translation={t}
                                                   filterOptions={listFilterOptions}
                                                   filterOptionsChanged={(newOptions) => setListFilterOptions(newOptions)}
                                                   searchTextChanged={(newText) => setSearchText(newText)}
                    />}
                </div>
            </div>

        </div>
    );
};

export default ReservationService;
